export const selectWorkspaces = (state: Store.State) => ({
  group: selectGroupWorkspace(state),
  personal: selectPersonalWorkspace(state),
});

export const selectGetWorkspace = (state: Store.State) => (workspaceId: number) => state.workspaces.values[workspaceId];
export const selectWorkspace = (workspaceId: number) => (state: Store.State) => state.workspaces.values[workspaceId];
export const selectGroupWorkspace = (state: Store.State) => state.workspaces.values[state.workspaces.group];
export const selectPersonalWorkspace = (state: Store.State) => state.workspaces.values[state.workspaces.personal];
